import { useMemo } from 'react'

import {
  FieldBaseLayout,
  FieldBaseError,
  FieldBaseDescription,
  FieldBaseLabel,
} from 'components/formKit'
import type { IFieldLayoutProps } from 'components/formKit/types'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getNodeId } from 'services/Store/Project/selectors'
import { selectRealtimeUsers } from 'services/Store/Users/selectors'
import { useAppSelector } from 'services/Store/hooks'

import * as s from './FieldLayoutActiveUsers.module.scss'

const FieldLayoutActiveUsers: React.FC<IFieldLayoutProps> = ({ children, ...props }) => {
  const { name: field } = props
  const nodeId = useProjectContext(getNodeId)
  const realtimeUsers = useAppSelector((s) => selectRealtimeUsers(s, { field, nodeId }))
  const users = useMemo(
    () => realtimeUsers.map((u) => ({ ...u?.employee, name: u?.employee?.kUser.name })),
    [realtimeUsers],
  )

  return (
    <FieldBaseLayout {...props}>
      {users.map((user) => (
        <div
          className={s.user}
          key={user.id}
          style={{ borderColor: user.color, background: `${user.color}22` }}
        >
          <div className={s.userName} style={{ background: user.color }}>
            {user.name}
          </div>
        </div>
      ))}
      <FieldBaseLabel {...props} />
      <FieldBaseDescription {...props} />
      {children}
      <FieldBaseError {...props} />
    </FieldBaseLayout>
  )
}

export default FieldLayoutActiveUsers
